import { Navigate } from 'react-router-dom';

import { useAuthContext, useAuthInitializedContext } from '../../hooks/use-user-auth-context.hooks';
import { User } from '../../redux/slice/auth/auth.types';

export interface AuthenticatedPageProps {
  render: () => JSX.Element;
}

export const AuthenticatedPage: React.FC<AuthenticatedPageProps> = ({
  render,
}: AuthenticatedPageProps) => {
  const user: User | null = useAuthContext();
  const isAuthenticated: boolean = user ? true : false;
  const isAuthInitialized: boolean = useAuthInitializedContext();

  if (!isAuthInitialized) {
    return <div>Loading...</div>;
  } else if (!isAuthenticated) {
    return <Navigate to="/login" />;
  } else {
    return render();
  }
};
